export const CREATE_GAME = "CREATE_GAME";
export const UPDATE_VIEW = "UPDATE_VIEW";
export const SET_GAME_DIFFICULTY = "SET_GAME_DIFFICULTY";
export const UPDATE_PREVIOUS_GAME_STATE = "UPDATE_PREVIOUS_GAME_STATE";
export const UPDATE_GAME_STATE = "UPDATE_GAME_STATE";
export const UPDATE_ATTEMPTS = "UPDATE_ATTEMPTS";
export const CREATE_CARDLIST = "CREATE_CARDLIST";
export const FLIP_CARDS = "FLIP_CARDS";
export const UPDATE_CARDS = "UPDATE_CARDS";
export const ADD_SELECTED_CARD = "ADD_SELECTED_CARD";
export const CLEAR_SELECTED_CARDS = "CLEAR_SELECTED_CARDS";
export const TOGGLE_SOUND = "TOGGLE_SOUND";
